/* eslint-disable quote-props */
import {
  stripCountryCode,
  getInputFieldsValuesFromResponse,
  updateStateOnInvoiceError,
  updateStateOnAddressError,
  updateFieldOnSetValue,
  getConfirmationClearedFields,
  clearPostCodeFieldWithError,
} from './utils';
import {
  SET_LOADING,
  SET_CONFIRMING,
  SET_ADDRESS_VALUE,
  USER_CONTACT_LOAD,
  USER_CONTACT_ERROR,
  USER_CONTACT_SUCCESS,
  PREPOPULATED_DATA_LOAD,
  PREPOPULATED_DATA_SUCCESS,
  PREPOPULATED_DATA_ERROR,
  SERVICE_POINTS_SUCCESS,
  CURRENT_SERVICE_POINTS_SELECT,
  NEARBY_SERVICE_POINTS_SUCCESS,
  SERVICE_POINT_SELECT,
  SERVICE_POINT_SUCCESS,
  SERVICE_POINT_ERROR,
  SET_DIRTY,
  DISPLAY_PREPOPULATED_DATA,
  CLEAR_PREPOPULATED_DATA,
  CHECK_VALIDATION,
  SERVICE_POINTS_ERROR,
  POST_ORDER_SUCCESS,
  POST_ORDER_LOAD,
  POST_ORDER_ERROR,
  ATLAS_AD_SUCCESS,
  ATLAS_AD_LOAD,
  PRICE_PREVIEW_SUCCESS,
  PRICE_PREVIEW_LOAD,
  OPERATORS_SUCCESS,
  PRICE_PREVIEW_ERROR,
  POST_CONTRACT_LOAD,
  POST_CONTRACT_SUCCESS,
  POST_CONTRACT_ERROR,
  SET_OFFER,
  POST_CONTRACT_ERROR_POSTCODE_NOT_SUPPORTED,
  POST_CONTRACT_ERROR_ORDER_NOT_FOUND,
  POST_CONTRACT_ERROR_OFFER_DOES_NOT_BELONG_TO_SELLER,
  POST_CONTRACT_ERROR_ORDER_IS_NOT_ACTIVE,
  POST_CONTRACT_ERROR_ADDRESS_DOES_NOT_BELONG_TO_SELLER,
  POST_CONTRACT_ERROR_ORDER_ALREADY_HAS_CONTRACT,
  POST_CONTRACT_ERROR_INVALID_FORMAT,
  POST_CONTRACT_ERROR_NOT_EMPTY,
  POST_CONTRACT_ERROR_MAX_LENGTH,
  CLEAR_ORDER_ERRORS,
  ATLAS_AD_ERROR,
  POST_ORDER_ERROR_PAYMENT_METHOD_NOT_SUPPORTED,
  POST_ORDER_ERROR_AD_STATUS_CHANGED,
  POST_ORDER_ERROR_POSTCODE_NOT_SUPPORTED,
  SHIPMENT_METHODS_LOAD,
  SHIPMENT_METHODS_SUCCESS,
  POST_ORDER_ERROR_PAYMENT_ALREADY_EXISTS,
  POST_ORDER_ERROR_SELLER_ACCOUNT_BLOCKED,
  POST_ORDER_ERROR_SELLER_ACCOUNT_CREATION_PENDING,
  POST_ORDER_ERROR_OFFER_ALREADY_ORDERED,
  POST_ORDER_ERROR_INVALID_ISO_COUNTRY_CODE,
  SET_CURRENT_OPERATOR,
  SET_DONATION_PRICE,
  POST_ORDER_ERROR_MIN_LENGTH,
  POST_ORDER_ERROR_MAX_LENGTH,
  POST_ORDER_ERROR_NOT_EMPTY,
  POST_ORDER_ERROR_INVALID_FORMAT,
  SET_INITIAL_ADDRESS_VALUE,
  SET_SHOULD_SAVE_DATA,
  SET_REQUEST_INVOICE,
  SET_REQUEST_INVOICE_TYPE,
  SET_REQUEST_INVOICE_VALUE,
  SET_ADDRESS_DATA_TO_REQUEST_INVOICE_FORM,
  TOGGLE_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM,
  UNSET_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM,
  SET_PAYU_DETAILS_VALUE,
  ATLAS_COUNTRIES_LOAD,
  ATLAS_COUNTRIES_SUCCESS,
  ATLAS_COUNTRIES_ERROR,
  SET_PREPOPULATED_DATA_CONSENT_CHECKED,
  SET_PREPOPULATED_DATA_IS_LEGACY,
  PREFILL_PREPOPULATED_DATA,
  POST_BILLING_ERROR_NOT_EMPTY,
  POST_BILLING_ERROR_MAX_LENGTH,
  POST_BILLING_ERROR_INVALID_FORMAT,
  POST_BILLING_ERROR_POSTCODE_NOT_SUPPORTED,
  LOADING_SELLER_DETAILS,
  GET_SELLER_DETAILS,
  SET_KEEP_OLX_DELIVERY,
  LOYALTY_POINTS_FLAG_HUB_VISIBLE_LOAD,
  LOYALTY_POINTS_FLAG_HUB_VISIBLE_SUCCESS,
  LOYALTY_POINTS_FLAG_HUB_VISIBLE_ERROR,
  LOYALTY_POINTS_OPT_IN_STATUS_LOAD,
  LOYALTY_POINTS_OPT_IN_STATUS_ERROR,
  LOYALTY_POINTS_OPT_IN_STATUS_SUCCESS,
  LOYALTY_POINTS_OPT_IN_CHECK_TOGGLE,
  LOYALTY_POINTS_PREVIEW_POINTS_ERROR,
  LOYALTY_POINTS_PREVIEW_POINTS_LOAD,
  LOYALTY_POINTS_PREVIEW_POINTS_SUCCESS,
  LOYALTY_POINTS_WHITELIST_USER_ERROR,
  LOYALTY_POINTS_WHITELIST_USER_SUCCESS,
  LOYALTY_POINTS_WHITELIST_USER_LOAD,
} from './actions';

import { OrderStore, PriceComponent } from './order-store';
import {
  ERROR_SERVICE_POINT_API,
  ERROR_SUBMIT_FORM_API,
  ERROR_OFFER_ALREADY_ORDERED,
  ERROR_CONTACT_DATA_API,
} from './error-codes';
import { Action } from '../../../typings';

import { USER_TYPE, ERROR_MESSAGES, FIELD_NAMES } from '../../constants';
import invoiceDefinitions from '../invoice/invoice-definitions';

export const getInitialState = (
  adId: string | null = null,
  orderId: string | null = null,
): OrderStore => ({
  ad: { id: Number(adId), user: null, url: null },
  orderId,
  offerId: null,
  paymentRedirect: null,
  confirmationRedirect: null,
  address: {},
  invoice: {},
  isInvoiceOptIn: false,
  invoiceType: '',
  useDeliveryDetailsForInvoice: false,
  payuDetails: {},
  invalidZIPList: [],
  servicePoint: null,
  servicePointByOperators: {},
  servicePointsMapError: false,
  nearbyServicePoints: [],
  servicePointsMap: null,
  shipmentMethods: null,
  cost: null,
  dirty: false,
  valid: false,
  shouldSaveData: true,
  confirming: false,
  loading: false,
  pageError: null,
  orderErrors: [],
  contractId: null,
  currentServicePoint: null,
  currentServicePointByOperators: {},
  prepopulatedData: null,
  prepopulatedDataError: null,
  prepopulatedDataConsentChecked: false,
  // TODO: DO-3088 Clean Up - Legacy Prefill
  prepopulatedDataIsLegacy: false,
  isReturningBuyer: false,
  formErrors: [],
  operators: [],
  currentOperator: '',
  isOptIn: false,
  apiError: null,
  countries: [{ id: 'PL', label: 'Polska' }],
  areCountriesLoading: false,
  sellerDetails: null,
  loadingSellerDetails: false,
  loyaltyProgram: {
    hubVisibilityFlagStatus: {
      status: 'LOADING',
      response: null,
    },
    optInStatus: {
      status: 'LOADING',
      response: null,
    },
    previewPoints: {
      status: 'LOADING',
      response: null,
    },
    optInCheck: false,
    userWhitelistStatus: 'NOT_WHITELISTED',
  },
});

export default function orderReducer(
  state: OrderStore,
  { type, payload }: Action<any>,
): OrderStore {
  switch (type) {
  case SET_LOADING:
    return { ...state, loading: payload };

  case SET_OFFER:
    return { ...state, offerId: payload };

  case SET_CONFIRMING:
    return {
      ...state,
      confirming: payload,
    };

  case SET_SHOULD_SAVE_DATA:
    return {
      ...state,
      shouldSaveData: payload,
    };

  case PREFILL_PREPOPULATED_DATA: {
    const servicePoint = state.prepopulatedData?.servicePoint || null;
    const operator = servicePoint?.attributes.operator ?? state.currentOperator;
    const inputFieldsValues = getInputFieldsValuesFromResponse(state.prepopulatedData?.address);
    return {
      ...state,
      currentServicePoint: servicePoint,
      servicePoint,
      currentOperator: operator,
      currentServicePointByOperators: {
        ...state.currentServicePointByOperators,
        [operator]: servicePoint,
      },
      servicePointByOperators: {
        ...state.servicePointByOperators,
        [operator]: servicePoint,
      },
      address: {
        ...state.address,
        ...inputFieldsValues,
      },
    };
  }

  // TODO: DO-3088 Clean Up - Legacy Prefill Banner
  case DISPLAY_PREPOPULATED_DATA: {
    const servicePoint = payload?.servicePoint;
    const operator = servicePoint?.attributes?.operator;
    const prepopulatedUserData = {
      ...payload?.contact,
      ...payload?.address,
    };
    const inputFieldsValues = getInputFieldsValuesFromResponse(prepopulatedUserData);

    return {
      ...state,
      currentServicePoint: servicePoint,
      servicePoint,
      currentOperator: operator,
      currentServicePointByOperators: {
        ...state.currentServicePointByOperators,
        [operator]: servicePoint,
      },
      servicePointByOperators: {
        ...state.servicePointByOperators,
        [operator]: servicePoint,
      },
      address: {
        ...state.address,
        ...inputFieldsValues,
      },
    };
  }

  case CLEAR_PREPOPULATED_DATA:
    return {
      ...state,
      prepopulatedData: null,
    };

  case SET_PREPOPULATED_DATA_CONSENT_CHECKED:
    return {
      ...state,
      prepopulatedDataConsentChecked: payload,
    };

    // TODO: DO-3088 Clean Up - Legacy Prefill
  case SET_PREPOPULATED_DATA_IS_LEGACY:
    return {
      ...state,
      prepopulatedDataIsLegacy: payload,
    };

  case CHECK_VALIDATION:
    return { ...state, valid: payload };

  case SET_DIRTY:
    return { ...state, dirty: payload };

  case SET_PAYU_DETAILS_VALUE:
    return {
      ...state,
      payuDetails: {
        ...state.payuDetails,
        [payload.input]: { ...state.payuDetails[payload.input], ...payload },
      },
    };

  case SET_ADDRESS_VALUE:
    return {
      ...state,
      address: {
        ...state.address,
        [payload.input]: updateFieldOnSetValue(state.address[payload.input], payload),
      },
    };

  case SET_INITIAL_ADDRESS_VALUE:
    return {
      ...state,
      address: {
        ...state.address,
        ...payload,
      },
    };

  case SET_REQUEST_INVOICE:
    return {
      ...state,
      isInvoiceOptIn: payload,
      invoice: payload ? { countryCode: invoiceDefinitions.countryField } : {},
      invoiceType: payload ? state.invoiceType || USER_TYPE.BUSINESS : '',
    };

  case SET_REQUEST_INVOICE_TYPE:
    return {
      ...state,
      invoiceType: payload,
      invoice: {
        countryCode: invoiceDefinitions.countryField,
      },
    };

  case SET_REQUEST_INVOICE_VALUE:
    return {
      ...state,
      invoice: {
        ...state.invoice,
        [payload.input]: {
          ...state.invoice[payload.input],
          ...payload,
        },
      },
    };
  case SET_ADDRESS_DATA_TO_REQUEST_INVOICE_FORM:
    return {
      ...state,
      invoice: {
        ...state.invoice,
        ...payload,
      },
    };
  case TOGGLE_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM:
    return {
      ...state,
      useDeliveryDetailsForInvoice: payload,
      invoice: getConfirmationClearedFields(payload, state.invoiceType, state.invoice),
    };
  case UNSET_USE_DELIVERY_DETAILS_FOR_INVOICE_FORM:
    return {
      ...state,
      useDeliveryDetailsForInvoice: false,
    };

  case ATLAS_AD_SUCCESS:
    return {
      ...state,
      loading: false,
      ad: payload,
      isOptIn: (payload?.delivery?.rock?.offer_id && payload?.delivery?.rock?.active) || false,
    };

  case ATLAS_AD_ERROR:
    return {
      ...state,
      loading: false,
      pageError: {
        title: payload.message || `dlv_error_http_${payload.status}`,
      },
    };

  case PRICE_PREVIEW_SUCCESS: {
    return {
      ...state,
      cost: payload?.data?.components as PriceComponent,
      costError: false,
    };
  }

  case PRICE_PREVIEW_ERROR: {
    return {
      ...state,
      costError: true,
    };
  }

  case POST_CONTRACT_SUCCESS:
    if (payload.data.type === 'kyc-redirect') {
      return { ...state, confirmationRedirect: payload.data.url };
    }

    return {
      ...state,
      contractId: payload.data.id,
    };

  case POST_ORDER_SUCCESS:
    if (payload.data.type === 'payment-redirect') {
      return { ...state, paymentRedirect: payload.data.url };
    }
    return {
      ...state,
      orderId: payload.data.id,
    };

  case SERVICE_POINTS_SUCCESS:
    return {
      ...state,
      servicePointsMap: {
        ...state.servicePointsMap,
        [payload.operator]: payload.servicePointsMap,
      },
      servicePointsMapError: false,
    };

  case NEARBY_SERVICE_POINTS_SUCCESS:
    return {
      ...state,
      nearbyServicePoints: payload,
    };

  case CURRENT_SERVICE_POINTS_SELECT:
    return {
      ...state,
      currentServicePoint: payload,
      currentServicePointByOperators: {
        ...state.currentServicePointByOperators,
        [payload.attributes.operator]: payload,
      },
    };

  case SERVICE_POINT_SUCCESS: {
    return {
      ...state,
      currentServicePoint: payload.data,
      currentServicePointByOperators: {
        ...state.currentServicePointByOperators,
        [payload.data.attributes.operator]: payload.data,
      },
    };
  }

  case SERVICE_POINT_ERROR: {
    return {
      ...state,
      apiError: ERROR_SERVICE_POINT_API,
    };
  }

  case SERVICE_POINT_SELECT: {
    const operatorServicePoint = payload ? { [payload.attributes.operator]: payload } : {};
    return {
      ...state,
      servicePoint: payload,
      servicePointByOperators: {
        ...state.servicePointByOperators,
        ...operatorServicePoint,
      },
    };
  }

  case CLEAR_ORDER_ERRORS:
    return {
      ...state,
      orderErrors: [],
    };

  case OPERATORS_SUCCESS:
    return {
      ...state,
      operators: payload,
    };

  case SET_CURRENT_OPERATOR:
    return {
      ...state,
      currentOperator: payload,
    };

  case SET_DONATION_PRICE:
    return {
      ...state,
      currentDonation: payload,
    };

  case SHIPMENT_METHODS_SUCCESS:
    return {
      ...state,
      shipmentMethods: payload,
    };

  case PREPOPULATED_DATA_LOAD:
  case SHIPMENT_METHODS_LOAD:
  case ATLAS_AD_LOAD:
  case PRICE_PREVIEW_LOAD:
  case POST_CONTRACT_LOAD:
  case USER_CONTACT_LOAD:
    return { ...state, loading: true };

  case POST_ORDER_LOAD:
    return { ...state, loading: true, orderErrors: [] };

  case POST_ORDER_ERROR:
  case POST_CONTRACT_ERROR:
    return {
      ...state,
      apiError: ERROR_SUBMIT_FORM_API,
      loading: false,
      confirming: false,
      formErrors: Array.isArray(payload?.errors) ? payload.errors : [],
    };

  case POST_CONTRACT_ERROR_POSTCODE_NOT_SUPPORTED:
  case POST_ORDER_ERROR_POSTCODE_NOT_SUPPORTED: {
    if (payload?.source?.pointer?.includes('invoice')) {
      const stateWithInvoiceError = updateStateOnInvoiceError(
        state,
        payload.field,
        ERROR_MESSAGES.postalCode,
        true,
      );
      return {
        ...stateWithInvoiceError,
        invalidZIPList: [
          ...stateWithInvoiceError.invalidZIPList,
          state.invoice[payload.field].value,
        ],
      };
    }
    // clear invoice post code when there is contract post code error
    const invoiceWithPostCodeError = clearPostCodeFieldWithError(
      !!state.useDeliveryDetailsForInvoice,
      state.invoice,
      payload.field,
    );
    const stateWithAddressError = updateStateOnAddressError(
      state,
      payload.field,
      ERROR_MESSAGES.postalCode,
      true,
    );
    return {
      ...stateWithAddressError,
      invoice: invoiceWithPostCodeError,
      invalidZIPList: [
        ...stateWithAddressError.invalidZIPList,
        state.address[payload.field].value,
      ],
    };
  }
  case POST_BILLING_ERROR_POSTCODE_NOT_SUPPORTED: {
    // clear address post code when there is billing post code error
    const addressWithPostCodeError = clearPostCodeFieldWithError(
      !!state.useDeliveryDetailsForInvoice,
      state.address,
      payload.field,
    );
    const stateWithInvoiceError = updateStateOnInvoiceError(
      state,
      payload.field,
      ERROR_MESSAGES.postalCode,
      true,
    );
    return {
      ...stateWithInvoiceError,
      address: addressWithPostCodeError,
      invalidZIPList: [
        ...stateWithInvoiceError.invalidZIPList,
        state.invoice[payload.field].value,
      ],
    };
  }

  case POST_ORDER_ERROR_SELLER_ACCOUNT_CREATION_PENDING:
  case POST_ORDER_ERROR_SELLER_ACCOUNT_BLOCKED:
  case POST_ORDER_ERROR_PAYMENT_ALREADY_EXISTS:
  case POST_ORDER_ERROR_OFFER_ALREADY_ORDERED:
  case ERROR_OFFER_ALREADY_ORDERED:
    return {
      ...state,
      loading: false,
      pageError: {
        title: `dlv_error_${payload.code.toLowerCase()}`,
        description: `dlv_error_info_${payload.code.toLowerCase()}`,
      },
    };

  case POST_ORDER_ERROR_PAYMENT_METHOD_NOT_SUPPORTED:
  case POST_ORDER_ERROR_AD_STATUS_CHANGED:
  case POST_CONTRACT_ERROR_ORDER_NOT_FOUND:
  case POST_CONTRACT_ERROR_OFFER_DOES_NOT_BELONG_TO_SELLER:
  case POST_CONTRACT_ERROR_ORDER_IS_NOT_ACTIVE:
  case POST_CONTRACT_ERROR_ADDRESS_DOES_NOT_BELONG_TO_SELLER:
  case POST_CONTRACT_ERROR_ORDER_ALREADY_HAS_CONTRACT:
    return {
      ...state,
      apiError: payload.code,
      orderErrors: [
        ...state.orderErrors,
        [`dlv_error_${payload.code.toLocaleLowerCase()}`, null],
      ],
      loading: false,
      confirming: false,
    };

  case POST_ORDER_ERROR_MIN_LENGTH: {
    const stateWithAddressError = updateStateOnAddressError(
      state,
      payload.field,
      'dlv_validation_min_length',
    );
    return { ...stateWithAddressError };
  }

  case POST_ORDER_ERROR_MAX_LENGTH:
  case POST_CONTRACT_ERROR_MAX_LENGTH: {
    if (payload?.source?.pointer?.includes('invoice')) {
      const stateWithInvoiceError = updateStateOnInvoiceError(
        state,
        payload.field,
        ERROR_MESSAGES.length,
      );
      return { ...stateWithInvoiceError };
    }

    const stateWithAddressError = updateStateOnAddressError(
      state,
      payload.field,
      ERROR_MESSAGES.length,
    );
    return { ...stateWithAddressError };
  }
  case POST_BILLING_ERROR_MAX_LENGTH: {
    const stateWithInvoiceError = updateStateOnInvoiceError(
      state,
      payload.field,
      ERROR_MESSAGES.length,
    );
    return { ...stateWithInvoiceError };
  }

  case POST_ORDER_ERROR_NOT_EMPTY:
  case POST_CONTRACT_ERROR_NOT_EMPTY: {
    if (payload?.source?.pointer?.includes('invoice')) {
      const stateWithInvoiceError = updateStateOnInvoiceError(state, payload.field);
      return { ...stateWithInvoiceError };
    }

    const stateWithAddressError = updateStateOnAddressError(state, payload.field);
    return { ...stateWithAddressError };
  }
  case POST_BILLING_ERROR_NOT_EMPTY: {
    const stateWithInvoiceError = updateStateOnInvoiceError(state, payload.field);
    return { ...stateWithInvoiceError };
  }

  case POST_ORDER_ERROR_INVALID_FORMAT:
  case POST_CONTRACT_ERROR_INVALID_FORMAT:
    if (payload?.source?.pointer === '/data/attributes/sellerIban') {
      return {
        ...state,
        valid: false,
        loading: false,
        confirming: false,
        orderErrors: [
          ...state.orderErrors,
          ['dlv_order_confirm_bankinfo', ERROR_MESSAGES.patternMatch],
        ],
        address: {
          ...state.address,
          bank: { ...state.address.bank, error: ERROR_MESSAGES.patternMatch },
        },
      };
    }
    if (payload?.source?.pointer?.includes('invoice')) {
      const stateWithInvoiceError = updateStateOnInvoiceError(
        state,
        payload.field,
        ERROR_MESSAGES.patternMatch,
      );
      return { ...stateWithInvoiceError };
    }
    return state;
  case POST_BILLING_ERROR_INVALID_FORMAT: {
    const stateWithInvoiceError = updateStateOnInvoiceError(
      state,
      payload.field,
      ERROR_MESSAGES.vatNumberFormat,
    );
    return { ...stateWithInvoiceError };
  }

  case POST_ORDER_ERROR_INVALID_ISO_COUNTRY_CODE: {
    const stateWithInvoiceError = updateStateOnInvoiceError(
      state,
      payload.field,
      ERROR_MESSAGES.patternMatch,
    );
    return { ...stateWithInvoiceError };
  }

  case USER_CONTACT_ERROR:
    return { ...state, loading: false, apiError: ERROR_CONTACT_DATA_API };
  case PREPOPULATED_DATA_ERROR:
    return {
      ...state,
      loading: false,
      prepopulatedDataError: { status: payload?.status },
    };
  case SERVICE_POINTS_ERROR:
    return { ...state, loading: false, servicePointsMapError: true };
  case PREPOPULATED_DATA_SUCCESS: {
    return {
      ...state,
      loading: false,
      isReturningBuyer: true,
      prepopulatedData: payload,
    };
  }
  case USER_CONTACT_SUCCESS: {
    const phoneNumber = state.address?.phoneNumber;
    return {
      ...state,
      loading: false,
      address: {
        ...state.address,
        email: {
          input: FIELD_NAMES.email,
          value: payload.data.attributes.email,
          valid: !!payload.data.attributes.email,
        },
        phoneNumber: {
          input: FIELD_NAMES.phoneNumber,
          value: phoneNumber?.value ?? stripCountryCode(payload.data.attributes.phoneNumber),
          valid: !!payload.data.attributes.phoneNumber,
        },
      },
    };
  }

  case ATLAS_COUNTRIES_LOAD:
    return { ...state, areCountriesLoading: true };
  case ATLAS_COUNTRIES_SUCCESS:
    return { ...state, areCountriesLoading: false, countries: payload };
  case ATLAS_COUNTRIES_ERROR:
    return { ...state, areCountriesLoading: false };
  case LOYALTY_POINTS_FLAG_HUB_VISIBLE_LOAD:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        hubVisibilityFlagStatus: {
          ...state.loyaltyProgram.hubVisibilityFlagStatus,
          status: 'LOADING',
          response: 'NOT_VISIBLE',
        },
      },
    };
  case LOYALTY_POINTS_FLAG_HUB_VISIBLE_SUCCESS:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        hubVisibilityFlagStatus: {
          ...state.loyaltyProgram.hubVisibilityFlagStatus,
          status: 'SUCCESS',
          response: payload,
        },
      },
    };
  case LOYALTY_POINTS_FLAG_HUB_VISIBLE_ERROR:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        hubVisibilityFlagStatus: {
          ...state.loyaltyProgram.hubVisibilityFlagStatus,
          status: 'ERROR',
          response: 'NOT_VISIBLE',
        },
      },
    };
  case LOYALTY_POINTS_OPT_IN_STATUS_LOAD:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        optInStatus: {
          ...state.loyaltyProgram.optInStatus,
          status: 'LOADING',
          response: null,
        },
      },
    };
  case LOYALTY_POINTS_OPT_IN_STATUS_SUCCESS:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        optInStatus: {
          ...state.loyaltyProgram.optInStatus,
          status: 'SUCCESS',
          response: payload,
        },
      },
    };
  case LOYALTY_POINTS_OPT_IN_STATUS_ERROR:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        optInStatus: {
          ...state.loyaltyProgram.optInStatus,
          status: 'ERROR',
          response: null,
        },
      },
    };
  case LOYALTY_POINTS_PREVIEW_POINTS_LOAD:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        previewPoints: {
          ...state.loyaltyProgram.previewPoints,
          status: 'LOADING',
          response: null,
        },
      },
    };
  case LOYALTY_POINTS_PREVIEW_POINTS_SUCCESS:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        previewPoints: {
          ...state.loyaltyProgram.previewPoints,
          status: 'SUCCESS',
          response: payload,
        },
      },
    };
  case LOYALTY_POINTS_PREVIEW_POINTS_ERROR:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        previewPoints: {
          ...state.loyaltyProgram.previewPoints,
          status: 'ERROR',
          response: null,
        },
      },
    };
  case LOYALTY_POINTS_OPT_IN_CHECK_TOGGLE:
    return {
      ...state,
      loyaltyProgram: { ...state.loyaltyProgram, optInCheck: !state.loyaltyProgram.optInCheck },
    };
  case LOYALTY_POINTS_WHITELIST_USER_SUCCESS:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        userWhitelistStatus: payload,
      },
    };
  case LOYALTY_POINTS_WHITELIST_USER_LOAD:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        userWhitelistStatus: payload,
      },
    };
  case LOYALTY_POINTS_WHITELIST_USER_ERROR:
    return {
      ...state,
      loyaltyProgram: {
        ...state.loyaltyProgram,
        userWhitelistStatus: 'NOT_WHITELISTED',
      },
    };

  case GET_SELLER_DETAILS:
    return {
      ...state,
      sellerDetails: payload,
      loadingSellerDetails: false,
    };
  case LOADING_SELLER_DETAILS:
    return { ...state, loadingSellerDetails: payload };

  case SET_KEEP_OLX_DELIVERY:
    return { ...state, keepOlxDelivery: payload };

  default:
    return state;
  }
}
